import { HlsConfig } from 'hls.js';
import { VideogularComponent } from '../../player/videogular/Videogular.Component';

import { HlsPeerPlayer } from '../HlsPeerPlayer';
import { IRevConnectInfo } from '@vbrick/vbrick-rev-connect/src/IRevConnectInfo';
import { multicastXhrConfig, removeQueryStr } from '../MulticastHlsUtil';

import { DualHlsLiveResumeHelper } from './DualHlsLiveResumeHelper';

export class DualHlsPlayer extends HlsPeerPlayer {
	public isPlayingAtBufferingStart: boolean;

	constructor(src: string, videoElement: HTMLVideoElement, API: VideogularComponent, isLive: boolean, isMulticast: boolean, revConnectInfo?: IRevConnectInfo, hlsJsConfigOverrides?: Partial<HlsConfig>, isStartPrefetch?: boolean) {
		super(isMulticast ? removeQueryStr(src) : src, videoElement, API, isLive, Object.assign({
			xhrConfig: isMulticast ? multicastXhrConfig(src) : null,
			playlistLoadPolicy: {
				default: {
					maxTimeToFirstByteMs: 10000,
					maxLoadTimeMs: isLive ? 20000 : 1000,
					timeoutRetry: {
						maxNumRetry: isMulticast ? 6 : isLive ? 5 : 2,
						retryDelayMs: 0,
						maxRetryDelayMs: 0
					},
					errorRetry: {
						maxNumRetry: isMulticast ? 6 : 5,
						retryDelayMs: 1000,
						maxRetryDelayMs: 8000
					}
				}
			},
			manifestLoadPolicy: {
				default: {
					maxTimeToFirstByteMs: Infinity,
					maxLoadTimeMs: isLive ? 20000 : 1000,
					timeoutRetry: {
						maxNumRetry: isMulticast ? 6 : isLive ? 5 : 2,
						retryDelayMs: 0,
						maxRetryDelayMs: 0
					},
					errorRetry: {
						maxNumRetry: isMulticast ? 6 : 5,
						retryDelayMs: 1000,
						maxRetryDelayMs: 8000
					}
				}
			},
			fragLoadPolicy: {
				default: {
					maxTimeToFirstByteMs: 10000,
					maxLoadTimeMs: isLive ? 12000 : 20000,
					timeoutRetry: {
						maxNumRetry: 2,
						retryDelayMs: 250,
						maxRetryDelayMs: 0
					},
					errorRetry: {
						maxNumRetry: isMulticast ? 11 : 6, //VBM needs more retries.
						retryDelayMs: 350,
						maxRetryDelayMs: 8000
					}
				}
			}
		}, hlsJsConfigOverrides), isStartPrefetch, revConnectInfo);
	}

	public get fLoader(): any {
		return this.player.config.fLoader;
	}

	public get pLoader(): any {
		return this.revConnectInfo ? this.hlsJsConfigOverrides.pLoader : undefined;
	}

	protected get isFragLoadWorker(): boolean {
		return this.hlsConfig.isFragLoadWorkerForDual;
	}

	public get nextLoadLevel(): number {
		return this.player.nextLoadLevel;
	}

	protected applySourceWithMSE() {
		this.resumeHelperClass = DualHlsLiveResumeHelper;

		return super.applySourceWithMSE();
	}

	protected onManifestParsed(): void {
		const { isMbrPlaybackDisabledForDual = false } = this.hlsConfig;

		if (isMbrPlaybackDisabledForDual) {
			this.player.nextLevel = this.player.levels.length - 1;
		}

		super.onManifestParsed();
	}

	public dualBufferingStart(): void {
		if (this.isBuffering) {
			if (!this.isPlaying) { //ensure that playing so it will load
				this.play();
			}
			return;
		}

		if (!this.isDualBuffering) {
			this.isPlayingAtBufferingStart = this.isPlaying;

			console.info(`dualBufferingStart - ${this.isPlayingAtBufferingStart}`);

			if (this.isPlayingAtBufferingStart && !this.isBuffering) {
				this.pause();
			}
		}
	}

	public dualBufferingEnd(): void {
		console.info('dualBufferingEnd');

		if (this.isPlayingAtBufferingStart && !this.isPlaying) {
			this.play();
		}

		this.isPlayingAtBufferingStart = null;
	}

	public get initialProgramDateTime(): Date {
		return this._initialProgramDateTime;
	}

	public get isDualBuffering(): boolean {
		return typeof this.isPlayingAtBufferingStart === 'boolean';
	}
}
